import { enetApiUrl, requestHttp, requestHttpUpload, requestOpen } from '@/utils';

let enetHost = process.env.VUE_APP_ENET_DEFAULT_API;
const curOrigin = window.location.origin;
if (enetApiUrl[curOrigin]) {
  enetHost = enetApiUrl[curOrigin];
}

const SERVER = ``;
const UMSERVER = ``;
// 方案的区域
const schemesApi = {
  reportTopoData: `${enetHost}/api/v1/schemes/scheme/report/topo-data`, // 方案 - 获取高清拓扑数据
  regionSort: `${SERVER}/scheme/region/sort`, // 楼层排序
  prodAttributeSubtree: `${SERVER}/mall/attr/new/list`, // 属性列表
  msgDetectStatus: `${SERVER}/scheme/msg/detect/status`, // 方案 - 消息 - 查询自动识别墙体提示
  msgDetectRead: `${SERVER}/scheme/msg/detect/read`, // 方案 - 消息 - 设置自动识别墙体提示
  schemeTransfer: `${SERVER}/scheme/transfer`, // 方案 - app,pc之间方案转换
  deviceTopo: `${SERVER}/scheme/device/topo/`, // 方案设备-获取拓扑图
  topoDevlist: `${SERVER}/scheme/device/topo_devlist/`, // 方案设备-获取拓扑视图设备列表
  prodDeviceInfo: `${SERVER}/scheme/prod/device/info`, // 方案产品 - 单台设备 - 属性详情
  prodDeviceEdit: `${SERVER}/scheme/prod/device/edit`, // 方案产品 - 单台设备 - 编辑属性
  regionRename: `${SERVER}/scheme/region/rename`, // 方案区域 - 重命名
  regionDelete: `${SERVER}/scheme/region/delete`, // 方案区域 - 删除
  regionCopy: `${SERVER}/scheme/region/copy`, // 方案区域 - 复制区域
  addSurvey: `${SERVER}/scheme/region/add-survey`, // 方案区域 - 地勘 - 新增区域
  prodListCount: `${SERVER}/prod/list-count`, // 产品 - 列表 - 计数
  regionDevList: `${SERVER}/scheme/region/dev/list`, // 方案区域 - 地勘 - 详情列表
  infoListSurvey: `${SERVER}/scheme/region/info-list-survey`, // 方案区域 - 地勘 - 详情列表
  delReginDevice: `${SERVER}/scheme/region/device/delete`, // 删除方案设备
  delReginIndoorDevice: `${SERVER}/scheme/region/indoor/device/delete`, // 室内设备批量删除
  delReginDevices: `${SERVER}/scheme/region/device/clear`, // 批量删除方案设备
  sceneList: `${SERVER}/scene/list`, // 查看方案场景列表
  prodCountList: `${SERVER}/prod/count/list`, // 产品 - 总数统计
  schemeAdd: `${SERVER}/scheme/add-survey`, // 方案 - 新增
  cartToScheme: `${SERVER}/scheme/cart-to-scheme-survey`, // 方案 - 购物车出方案
  cartProdAdd: `${SERVER}/cart-prod/add`, // 购物车产品 - 添加
  cartProdDelete: `${SERVER}/cart-prod/delete`, // 购物车产品 - 删除
  cartProdEmpty: `${SERVER}/cart-prod/empty`, // 购物车产品 - 清空
  cartProdList: `${SERVER}/cart-prod/list`, // 购物车产品 - 列表
  cartProdUpdate: `${SERVER}/cart-prod/update`, // 购物车产品 - 更新
  getMySchemeList: `${SERVER}/scheme/list`, // 查看我的方案列表
  schemeDelete: `${SERVER}/scheme/delete`, // 方案 - 删除
  schemeCaseList: `${SERVER}/scheme/case/list`, // 方案 - 精选 - 列表
  schemeInfo: `${SERVER}/scheme/info`, // 方案 - 详情
  schemeSectionInfo: `${SERVER}/scheme/section/info`, // 方案 - 章节 - 详情
  schemeProdTopo: `${SERVER}/scheme/prod/topo`, // 方案产品 - 拓扑 - 生成
  schemeUpdataTopo: `${SERVER}/scheme/device/topo-node/{schemeId}`, // 方案产品 - 拓扑 - 更新
  schemeHideTopo: `${SERVER}/scheme/device/topo-node-hide/{schemeId}`, //方案产品 -隐藏拓扑节点
  schemeTopoExpandStatus: `${SERVER}/scheme/device/topo-info/{schemeId}`, //拓扑图-获取/设置展开收起状态
  schemeSparkleAdd: `${SERVER}/scheme/sparkle/add`, // 方案 - 方案亮点 - 新增
  schemeSparkleList: `${SERVER}/scheme/sparkle/list`, // 方案 - 方案亮点 - 列表
  schemeSparkleTemplate: `${SERVER}/scheme/sparkle/template`, // 方案 - 方案亮点 - 模板
  schemeSparkleDelete: `${SERVER}/scheme/sparkle/delete`, // 方案 - 方案亮点 - 删除
  schemeSparkleUpdate: `${SERVER}/scheme/sparkle/update`, // 方案 - 方案亮点 - 更新
  schemeSparkleSort: `${SERVER}/scheme/sparkle/sort`, // 方案 - 方案亮点 - 排序
  schemeAddFloor: `${SERVER}/scheme/region/add-survey`, // 方案 -新增楼层
  schemeExport: `${SERVER}/scheme/report-survey`, //方案导出
  schemeExportAsync: `${SERVER}/scheme/report-survey-async`, //方案导出(异步)
  getReportStatus: `${SERVER}/scheme/report/{key}`, //查询异步报告
  schemeSingerDevMoveFloor: `${SERVER}/scheme/region/dev/move`, // 方案 - 产品移动楼层（单台）
  schemeDevicesMoveFloor: `${SERVER}/scheme/region/prod/transfer`, //方案 - 产品移动楼层（多台）
  schemeSparkAdd: `${SERVER}/scheme/section/add`, //方案-新增方案模块
  schemeCopy: `${SERVER}/scheme/copy`, // 方案 - 复制
  schemeProdPriceUpdate: `${SERVER}/scheme/prod/price/update`, // 方案产品 - 价格 - 批量修改
  schemeEditDeviceName: `${SERVER}/scheme/prod/rename`, // 方案产品 -单台设备-重名明
  schemeUpdate: `${SERVER}/scheme/update`, // 方案 - 更新
  schemeProdEmpty: `${SERVER}/scheme/prod/delete`, // 方案产品 - 删除
  schemeSort: `${SERVER}/scheme/prod/sort`, // 方案产品 - 排序
  schemePrivateList: `${SERVER}/prod/all/list`, // 产品 - 列表
  schemeProdReplace: `${SERVER}/scheme/prod/replace`, // 方案产品 - 替换（按设备）
  schemeProdReplaceRegion: `${SERVER}/scheme/region/prod/replace`, // 方案产品 - 替换（按楼层）
  schemeProdReplaceCurrent: `${SERVER}/scheme/region/dev/replace`, // 方案单台产品
  schemeProdAddProduct: `${SERVER}/scheme/region/prod/add`, //方案 - 追加
  schemeProdAdd: `${SERVER}/scheme/prod/add`, // 方案产品 - 添加
  schemeProdUpdate: `${SERVER}/scheme/prod/update`, // 方案产品 - 添加
  schemeExcel: `${SERVER}/scheme/excel`, // 私有产品 - 详情
  schemeCameraDict: `${SERVER}/step-list/dict/camera`, // 字典-摄像头
  schemeApDict: `${SERVER}/step-list/dict/ap`, // 字典-ap
  schemeBridgeDict: `${SERVER}/step-list/dict/bridge`, // 私有产品 - 详情
  schemeRegionInfoList: `${SERVER}/scheme/region/info-list`, // 方案区域 - 详情列表
  schemeRegionProdUpdate: `${SERVER}/scheme/region/prod/update`, // 方案区域 - 产品 - 更新数量
  schemeRegionProdSort: `${SERVER}/scheme/region/prod/sort`, // 方案区域 - 排序
  schemeRegionProdDelete: `${SERVER}/scheme/region/prod/delete`, // 方案区域 - 产品 - 删除
  schemeRegionProdUpsert: `${SERVER}/scheme/region/prod/upsert`, // 方案区域 - 产品 - 追加
  schemeRegionProdTransfer: `${SERVER}/scheme/region/prod/transfer`, // 方案区域 - 产品 - 转移
  stepShoppingList: `${SERVER}/step-list/shopping`, // 购物车-列表
  dictNetworkExport: `${SERVER}/step-list/dict/network-export`, // 字典-出口
  getSmartList: `${SERVER}/step-list/smart-compute-one`, // 步骤1
  getSmartExport: `${SERVER}/step-list/smart-export`, // 步骤4
  addShoppings: `${SERVER}/step-list/shoppings`, // 购物车-批量加入
  addShoppingsPrice: `${SERVER}/step-list/shoppings/price`, // 购物车-批量加入带价格
  addOneShopping: `${SERVER}/step-list/shopping`, // 购物车-更新
  deleteShopping: `${SERVER}/step-list/shopping`, // 购物车-批量删除
  prodStepSdPrivateList: `${SERVER}/step-list/filter-prod/list`, // 产品 - Lysora私有 - 列表
  smartExchange: `${SERVER}/step-list/smart-exchange`, // 步骤2-选交换
  smartCore: `${SERVER}/step-list/smart-core`, // 步骤3-选核心
  selectStepInfo: `${SERVER}/step-list/info`, // 步骤一，选场景
  dictExchange: `${SERVER}/step-list/dict/exchange`, // 字典-交换机
  floorData: `${SERVER}/step-list/info/region`, // 楼层接口
  terminalData: `${SERVER}/step-list/wired-terminal`, // 更新终端数
  smartExchangeOnelayer: `${SERVER}/step-list/smart-exchange-onelayer`, // 步骤2-选交换-指定楼层重新计算
  smartExchangePort: `${SERVER}/step-list/smart-exchange-port`, // 步骤2-选交换-修改端口
  shoppingCount: `${SERVER}/step-list/shopping-type`, // 购物车-类型总数
  prodCatAttrList: `${SERVER}/step-list/filter-prod/cat-attr/list`, // 更多产品属性
  stepToScheme: `${SERVER}/scheme/step-to-scheme`, // 方案 - 步骤出方案
  smartComputeOneNvr: `${SERVER}/step-list/smart-compute-one-nvr`, // 步骤1-NVR
  auxiliaryMaterials: `${SERVER}/step-list/auxiliary-materials`, // 步骤4-辅材列表
  getPrivateCart: `${SERVER}/category/private/list`, //私有分类 - 分类
  categoryShareList: `${SERVER}/category/share/list`, // 共享分类 - 列表
  prodShareList: `${SERVER}/prod/share/list`, // 共享产品 - 列表
  prodSharePackageList: `${SERVER}/prod/share/package/list`, // 共享产品 - 分享包 - 列表
  prodPrivateCopy: `${SERVER}/prod/private/batch/copy`, // 私有产品 - 收藏
  prodSdSourceList: `${SERVER}/prod/private/sd-source/list`, // 私有产品 - 查询来源自Lysora产品的id
  prodList: `${SERVER}/prod/list`, // 产品 - 列表
  prodPrivateShareCopy: `${SERVER}/prod/private/share/copy`, // 私有产品 - 一键收藏
  prodPrivateCancel: `${SERVER}/prod/private/cancel`, // 私有产品 - 取消收藏
  getPrivateList: `${SERVER}/prod/private/list`, // 私有产品 - 列表
  getPrivateImageUploadKey: `${SERVER}/prod/private/image/upload`, // 私有产品 - 获取图片上传密钥
  addPrivateProd: `${SERVER}/prod/private/add`, // 私有产品 - 新增
  editPrivateProd: `${SERVER}/prod/private/update`, // 私有产品 - 更新
  getAttrList: `${SERVER}/prod/attribute/cat/list`, // 私有产品 - 更新
  cancelCollect: `${SERVER}/prod/private/batch/delete`, // 私有产品 - 更新
  getSdPrivateCart: `${SERVER}/category/sd-private/list`, //私有分类 - 分类
  getPrivateInfo: `${SERVER}/prod/private/info`, // 私有产品 - 详情
  getShareInfo: `${SERVER}/prod/share/info`, // 共享产品 - 详情
  viewTimeUpdate: `${SERVER}/view-time/update`, // 页面进入次数 - 详情
  packageBrandList: `${SERVER}/prod/share/package/brand/list`, // 共享产品 - 品牌 - 列表
  privateExcelImport: `${SERVER}/prod/private/excel/import`, // 私有产品 - excel导入
  privateExcelExport: `${SERVER}/prod/private/excel/export`, // 私有产品 - excel导出
  privateBelongingSet: `${SERVER}/prod/private/belonging/set`, // 私有产品 - 设置归属
  privateTransferStatus: `${SERVER}/prod/private/old/transfer/status`, // 私有产品-迁移状态
  privateTransfer: `${SERVER}/prod/private/old/transfer`, // 私有产品-迁移旧版
  allTransfer: `${SERVER}/prod/all/transfer`, // 数据合并
  getBusinessCardUploadKey: `${SERVER}/cloud/objects/upload-key/get`, // 名片 - 上传图片秘钥签发
  projectMomentAdd: `${SERVER}/project-moment/add`, // 项目朋友圈-新增
  projectMomentDelete: `${SERVER}/project-moment/delete`, // 项目朋友圈-删除
  projectMomentImportFromScheme: `${SERVER}/project-moment/import-from-scheme`, // 项目朋友圈-从方案导入
  projectMomentInfo: `${SERVER}/project-moment/info`, // 项目朋友圈-详情
  projectMomentList: `${SERVER}/project-moment/list`, // 项目朋友圈-列表
  projectMomentOpenList: `${SERVER}/project-moment/open/list`, // 项目朋友圈-列表
  projectMomentEdit: `${SERVER}/project-moment/update`, // 项目朋友圈-更新
  prodRecommend: `${SERVER}/scheme/prod/recommend`, // 方案产品 - 推荐
  aiToScheme: `${SERVER}/scheme/ai-to-scheme`, // 方案 - 智能出方案
  regionProdAdd: `${SERVER}/scheme/region/prod/add`, // 方案区域 - 产品 - 追加
  schemeSectionUpdate: `${SERVER}/scheme/section/update`, // 章节 - 更新
  schemeSectionDelete: `${SERVER}/scheme/section/delete`, //章节 - 删除
  schemeSetDeviceChange: `${SERVER}/scheme/msg/device-change`, //设置设备已变更
  schemeGetDeviceChange: `${SERVER}/scheme/msg/device-change-info`, //查询设备是否变更
  schemeDelDeviceChange: `${SERVER}/scheme/msg/device-change-delete`, //清除设备已变更
  businessCardInfo: `${UMSERVER}/business-card/info`, // 名片-查看详情
  businessCardOpenInfo: `${UMSERVER}/business-card/open/info`, // 名片-查看详情(非登录状态)
  businessCardUpsert: `${UMSERVER}/business-card/upsert`, // 名片-插入或更新
  businessCardTitle: `${UMSERVER}/business-card/title/get`, // 名片-获取公司与个人称号
  businessCardOpenTitle: `${UMSERVER}/business-card/open/title/get`, // 名片-获取公司与个人称号(非登录状态)
  businessCardDownloadUrl: `${UMSERVER}/business-card/image/download-url`, // 名片-生成名片分享图片
  schemeRegionProdAdd: `${SERVER}/scheme/region/device/add`, // 方案区域 - 设备 - 添加，同时设置属性
  schemeRegionDeviceCopy: `${SERVER}/scheme/region/device/copy`, // 方案区域 - 设备 - 复制设备【scheme】
  schemeValidate: `${SERVER}/scheme/validate`, //方案- 清单校验器
  getSchemeUseMsgStatus: `${SERVER}/scheme/msg/user/status`,
  setSchemeUseMsgStatus: `${SERVER}/scheme/msg/user/read`,
  deviceEstLegend: `${SERVER}/scheme/device/est/legend`,
  getSchemeProdInfo: `${SERVER}/scheme/region/prod/info`, // 同型号设备 - 分布在楼层的详情
  getSchemeOutdoorProd: `${SERVER}/scheme/outdoor/prod`, // 方案 - 查询是否有室外设备
  getMallList: `${SERVER}/mall/list`, // 查看商品列表
  getMallProdInfo: `${SERVER}/mall/prod/batch/info`, // 根据产品ID批量查询
  schemeEmuBridge: `${SERVER}/scheme/emu/bridge`, // 方案 - 生成网桥demo项目
  regionProdFlywheel: `${SERVER}/scheme/region/prod/flywheel`, // 方案区域 - 产品 - 自动布点飞轮埋点
  prodWireList: `${SERVER}/prod/wire/list`, // 线缆列表
  regionSwDevlist: `${SERVER}/scheme/device/region/sw_devlist/{schemeId}/{regionId}`, // 方案设备-获取楼层交换层设备列表
  uplinkList: `${SERVER}/scheme/region/uplink/list`, // 方案区域 - 获取可上联的楼层列表
  setUplink: `${SERVER}/scheme/region/set-uplink`, // 方案区域 - 设置上联楼层
  regionUplink: `${SERVER}/scheme/region/uplink`, // 方案区域 - 获取上联楼层
  removeRegionUplink: `${SERVER}/scheme/region/uplink/delete`, // 方案区域 - 删除上联楼层
  deviceTopo2d: `${SERVER}/scheme/device/topo-2d/{schemeId}`, // 拓扑图-获取2D拓扑图
  deviceTopo3d: `${SERVER}/scheme/device/topo-3d/{schemeId}`, // 拓扑图-获取3D拓扑图
  deviceTopo3dV2: `${SERVER}/scheme/device/topo-3d/v2`, // 拓扑图-售前2.0-获取3D拓扑图
  deviceTopo3dV2Option: `${SERVER}/scheme/device/topo-3d/option`, // 拓扑图-售前2.0-获取3D拓扑图选项
  deviceTopo3dV2OptionUpdate: `${SERVER}/scheme/device/topo-3d/option/update`, // 拓扑图-售前2.0-设置3D拓扑图选项
  deviceTopoWireInfo: `${SERVER}/scheme/device/topo-wire-info/{schemeId}`, // 拓扑图-获取线材计算
  wireVerticalValid: `${SERVER}/scheme/wire/vertical/valid`, // 布线 - 垂直布线预校验
  wireCalculateVertical: `${SERVER}/scheme/wire/calculate/vertical`, // 布线 - 触发计算垂直布线
  deviceTopoShare: `${SERVER}/scheme/device/topo/share`, // 拓扑图-生成拓扑图分享链接
  reportSystemData: `${enetHost}/api/v1/schemes/scheme/report/system-data`, // 方案 - 获取2D-3D高清图数据
  autoProdList: `${SERVER}/auto-prod/list`, // 用户最近使用的产品 - 列表
  autoProdBatchAdd: `${SERVER}/auto-prod/batch/add`, // 用户最近使用的产品 - 添加
  resetLang: `${SERVER}/scheme/reset/lang`, // 方案 - 更新语言
  mallListSurvey: `${SERVER}/mall/list-survey`, // 产品库 - 仿真属性 - 产品列表
  wireDevUnwired: `${SERVER}/scheme/wire/dev/unwired`, // 布线-获取设备未自动布线原因
  schemeQuality: `${SERVER}/scheme/quality`, // 方案 - 获取质保
  setSchemeQuality: `${SERVER}/scheme/quality`, // 方案 - 设置质保
  regionWireList: `${SERVER}/scheme/region/wire/list`, // 方案区域 - 楼层线材列表
  schemeRegionEdit: `${SERVER}/scheme/region/edit`, // 楼层 - 编辑
  schemeRegionInfo: `${SERVER}/scheme/region/info`, // 楼层 - 详情
  powerProd: `${SERVER}/power/prod`, // 功率 - 获取楼层产品功率
  schemeWireRegionClear: `${SERVER}/scheme/wire/region/clear`, // 布线 - 清空该楼层所有线材产品【scheme】
  prodPreviewInfo: `${SERVER}/scheme/prod/prod/preview/info`, // 方案产品 - 预览设备信息【scheme】
  postFeedback: `${SERVER}/scheme/region/feedback`, // 方案 - 自动布点反馈【scheme】
  autoLanScaleValid: `${SERVER}/plan/scale/plan-valid`, // 校验比例尺的合法性
  prodHeatmapAllData: `${SERVER}/heatmap/all/data`, // 可以查看所有天线模型列表
  getPlanPrivacy: `${SERVER}/scheme/user/info`, // 方案 - 上传图片的隐私权限获取与编辑
  getWireProdList: `${SERVER}/scheme/region/wire/prod/list`, // 方案区域 - 楼层线材列表-按线材【scheme】
  getWallsCategoryList: `${SERVER}/project/obstacle/category/list`, // 方案 - 获取障碍物材质【scheme】
  getWallsList: `${SERVER}/project/obstacle/list`, // 方案 - 获取方案障碍物列表【scheme】
  postAddObstacle: `${SERVER}/project/obstacle/add`, // 添加自定义障碍物【scheme】
  postCopyObstacle: `${SERVER}/project/obstacle/copy`, // 方案 - 复制自定义障碍物【scheme】
  postUpdateObstacle: `${SERVER}/project/obstacle/update`, // 方案 - 修订自定义障碍物【scheme】
  delHasAppliedObstacle: `${SERVER}/project/obstacle/hasApplied`, // 方案 - 自定义障碍物是否已被应用【scheme】
  delObstacle: `${SERVER}/project/obstacle/delete`, // 方案 - 删除自定义障碍物【scheme】
  checkLightHelp: `${SERVER}/scheme/validate/help` // 方案- Light选型说明是否显示
};

export const prodPreviewInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodPreviewInfo,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeWireRegionClearApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeWireRegionClear,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionDeviceCopyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionDeviceCopy,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const powerProdApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.powerProd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionEditApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionEdit,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionInfo,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const regionWireListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionWireList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const schemeQualityApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeQuality,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const setSchemeQualityApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.setSchemeQuality,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const wireDevUnwiredApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.wireDevUnwired,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const mallListSurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.mallListSurvey,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const resetLangApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.resetLang,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const autoProdBatchAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.autoProdBatchAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const autoProdListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.autoProdList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const reportSystemDataApi = (data = {}) => {
  return requestOpen({
    api: schemesApi.reportSystemData,
    method: 'GET',
    module: 'schemes',
    query: data
  });
};

export const deviceTopoShareApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopoShare,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const wireVerticalValidApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.wireVerticalValid,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const wireCalculateVerticalApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.wireCalculateVertical,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const deviceTopo3dV2Api = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopo3dV2,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const deviceTopo3dV2OptionApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopo3dV2Option,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const deviceTopo3dV2OptionUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopo3dV2OptionUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const deviceTopo3dApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopo3d.replace('{schemeId}', data.schemeId),
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const deviceTopo2dApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopo2d.replace('{schemeId}', data.schemeId),
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const deviceTopoWireInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceTopoWireInfo.replace('{schemeId}', data.schemeId),
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const removeRegionUplinkApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.removeRegionUplink,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const regionUplinkApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionUplink,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const setUplinkApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.setUplink,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const uplinkListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.uplinkList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const regionSwDevlistApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionSwDevlist.replace('{schemeId}', data.schemeId).replace('{regionId}', data.regionId),
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const prodWireListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodWireList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const regionProdFlywheelApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionProdFlywheel,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const prodAttributeSubtree = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodAttributeSubtree,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const msgDetectStatusApi = () => {
  return requestHttp({
    api: schemesApi.msgDetectStatus,
    method: 'GET',
    module: 'schemes'
  });
};

export const msgDetectReadApi = () => {
  return requestHttp({
    api: schemesApi.msgDetectRead,
    method: 'POST',
    module: 'schemes',
    params: {}
  });
};

export const schemeTransferApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeTransfer,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const sceneListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.sceneList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const addSchemeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const cartToSchemeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.cartToScheme,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const cartProdAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.cartProdAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const cartProdDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.cartProdDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const cartProdEmptyApi = () => {
  return requestHttp({
    api: schemesApi.cartProdEmpty,
    method: 'POST',
    module: 'schemes',
    params: {}
  });
};

export const getCartProdListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.cartProdList,
    method: 'GET',
    module: 'schemes',
    querys: data,
    backErrorCode: true
  });
};

export const cartProdUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.cartProdUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getMySchemeListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getMySchemeList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeCaseListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeCaseList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeInfoApi = (data = {}) => {
  const isWireTestUser = JSON.parse(window.localStorage.getItem('isWireTestUser') || false);

  return requestHttp({
    api: schemesApi.schemeInfo,
    method: 'GET',
    module: 'schemes',
    querys: {
      showWireDesign: isWireTestUser,
      ...data.query
    }
  });
};

export const schemeSectionInfoApi = (data = {}) => {
  const isWireTestUser = JSON.parse(window.localStorage.getItem('isWireTestUser') || false);

  return requestHttp({
    api: schemesApi.schemeSectionInfo,
    method: 'GET',
    module: 'schemes',
    querys: {
      ...data.query,
      showVerticalRegion: isWireTestUser
    }
  });
};

export const schemeProdTopoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdTopo,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeUpdataTopoApi = (data = {}, schemeId) => {
  return requestHttp({
    api: schemesApi.schemeUpdataTopo.replace('{schemeId}', schemeId),
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeHideTopoApi = (data = {}, schemeId) => {
  return requestHttp({
    api: schemesApi.schemeHideTopo.replace('{schemeId}', schemeId),
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeGetTopoExpandStatusApi = schemeId => {
  return requestHttp({
    api: schemesApi.schemeTopoExpandStatus.replace('{schemeId}', schemeId),
    method: 'GET',
    module: 'schemes',
    querys: {},
    params: {}
  });
};

export const schemeSetTopoExpandStatusApi = (data = {}, schemeId) => {
  return requestHttp({
    api: schemesApi.schemeTopoExpandStatus.replace('{schemeId}', schemeId),
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSparkleAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkleAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSparkleListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkleList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeSparkleTemplateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkleTemplate,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeSparkleDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkleDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSparkleUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkleUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSparkleSortApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkleSort,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeAddFloorApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeAddFloor,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeExportApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeExport,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    timeout: 120 * 1000
  });
};

export const schemeExportAsyncApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeExportAsync,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getReportStatusApi = (data = {}, key) => {
  return requestHttp({
    api: schemesApi.getReportStatus.replace('{key}', key),
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeSingerDevMoveFloorApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSingerDevMoveFloor,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeDevicesMoveFloorApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeDevicesMoveFloor,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSparkAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSparkAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeCopyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeCopy,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdPriceUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdPriceUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeEditDeviceNameApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeEditDeviceName,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdEmptyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdEmpty,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSortApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSort,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemePrivateListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemePrivateList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const schemeProdReplaceApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdReplace,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdReplaceRegionApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdReplaceRegion,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdReplaceCurrentApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdReplaceCurrent,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdAddProductApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdAddProduct,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeProdUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeProdUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeExcelApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeExcel,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionInfoListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionInfoList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionProdSortApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionProdSort,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionProdUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionProdUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionProdDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionProdDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionProdUpsertApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionProdUpsert,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionProdTransferApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionProdTransfer,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const dictNetworkExportApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.dictNetworkExport,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const addShoppingsApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.addShoppings,
    method: 'put',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const addShoppingsPriceApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.addShoppingsPrice,
    method: 'put',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const addOneShoppingApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.addOneShopping,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const deleteShoppingApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deleteShopping,
    method: 'delete',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const prodStepSdPrivateListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodStepSdPrivateList,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const smartExchangeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.smartExchange,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const smartExchangeOnelayerApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.smartExchangeOnelayer,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const smartExchangePortApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.smartExchangePort,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const smartCoreApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.smartCore,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const dictExchangeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.dictExchange,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeCameraDict = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeCameraDict,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeApDict = (data = {}, type) => {
  return requestHttp({
    api: schemesApi.schemeApDict + `?type=${type}`,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeBridgeDict = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeBridgeDict,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const stepShoppingList = (data = {}) => {
  return requestHttp({
    api: schemesApi.stepShoppingList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

export const stepUpdateCart = (data = {}) => {
  return requestHttp({
    api: schemesApi.stepShoppingList,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const stepDeleteCart = (data = {}) => {
  return requestHttp({
    api: schemesApi.stepShoppingList,
    method: 'delete',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getSmartList = (data = {}) => {
  return requestHttp({
    api: schemesApi.getSmartList,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getSmartExportApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getSmartExport,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

// 步骤出方案-获取步骤
export const getStepInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.selectStepInfo,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

// 步骤出方案-创建
export const selectStepInfo = (data = {}) => {
  return requestHttp({
    api: schemesApi.selectStepInfo,
    method: 'put',
    querys: data.query || {},
    params: data.data || {}
  });
};

// 步骤出方案-清理数据
export const deleteStepInfo = (data = {}) => {
  return requestHttp({
    api: schemesApi.selectStepInfo,
    method: 'delete',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getFloorData = (data = {}) => {
  return requestHttp({
    api: schemesApi.floorData,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const addFloorData = (data = {}) => {
  return requestHttp({
    api: schemesApi.floorData,
    method: 'put',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const updateFloorData = (data = {}) => {
  return requestHttp({
    api: schemesApi.floorData,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const copyFloorData = (data = {}) => {
  return requestHttp({
    api: schemesApi.floorData + '/copy',
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const deleteFloorData = (data = {}) => {
  return requestHttp({
    api: schemesApi.floorData,
    method: 'delete',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getTerminalDataApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.terminalData,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

export const smartComputeOneNvrApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.smartComputeOneNvr,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const updateTerminalData = (data = {}) => {
  return requestHttp({
    api: schemesApi.terminalData,
    method: 'put',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const shoppingCountApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.shoppingCount,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

export const prodCatAttrListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodCatAttrList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    backErrorCode: true
  });
};

export const stepToSchemeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.stepToScheme,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const auxiliaryMaterialsApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.auxiliaryMaterials,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getPrivateCart = (data = {}) => {
  return requestHttp({
    api: schemesApi.getPrivateCart,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const categoryShareListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.categoryShareList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const prodShareListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodShareList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const prodSharePackageListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodSharePackageList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const prodPrivateCopyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodPrivateCopy,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const prodSdSourceListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodSdSourceList,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const prodListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const prodPrivateShareCopyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodPrivateShareCopy,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const prodPrivateCancelApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodPrivateCancel,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getPrivateList = (data = {}) => {
  return requestHttp({
    api: schemesApi.getPrivateList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {},
    backErrorCode: true
  });
};

export const getPrivateImageUploadKey = (data = {}) => {
  return requestHttp({
    api: schemesApi.getPrivateImageUploadKey,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const addPrivateProd = (data = {}) => {
  return requestHttp({
    api: schemesApi.addPrivateProd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const editPrivateProd = (data = {}) => {
  return requestHttp({
    api: schemesApi.editPrivateProd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getAttrList = (data = {}) => {
  return requestHttp({
    api: schemesApi.getAttrList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const cancelCollect = (data = {}) => {
  return requestHttp({
    api: schemesApi.cancelCollect,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getSdPrivateCart = (data = {}) => {
  return requestHttp({
    api: schemesApi.getSdPrivateCart,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const getPrivateInfo = (data = {}) => {
  return requestHttp({
    api: schemesApi.getPrivateInfo,
    method: 'GET',
    module: 'schemes',
    querys: data,
    backErrorCode: true
  });
};

export const getShareInfo = (data = {}) => {
  return requestHttp({
    api: schemesApi.getShareInfo,
    method: 'GET',
    module: 'schemes',
    querys: data,
    backErrorCode: true
  });
};

export const viewTimeUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.viewTimeUpdate,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const packageBrandListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.packageBrandList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const privateExcelImportApi = file => {
  return requestHttpUpload({
    file: file,
    uploadData: JSON.stringify({
      api: schemesApi.privateExcelImport,
      method: 'POST',
      module: 'schemes',
      fileName: 'file',
      contentType: 'application/octet-stream' // 此接口必须设置contentType
    })
  });
};

export const privateExcelExportApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.privateExcelExport,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const privateBelongingSetApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.privateBelongingSet,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const privateTransferStatusApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.privateTransferStatus,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const privateTransferApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.privateTransfer,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getBusinessCardUploadKey = (data = {}) => {
  return requestHttp({
    api: schemesApi.getBusinessCardUploadKey,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

export const projectMomentAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.projectMomentAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const projectMomentDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.projectMomentDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const projectMomentInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.projectMomentInfo,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const projectMomentImportFromSchemeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.projectMomentImportFromScheme,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const projectMomentList = (data = {}) => {
  if (data.query && data.query.type === 'share') {
    return requestHttp({
      api: schemesApi.projectMomentOpenList,
      method: 'GET',
      module: 'schemes',
      querys: data.query || {}
    });
  } else {
    return requestHttp({
      api: schemesApi.projectMomentList,
      method: 'GET',
      module: 'schemes',
      querys: data.query || {}
    });
  }
};

export const projectMomentEditApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.projectMomentEdit,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const prodRecommendApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodRecommend,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const aiToSchemeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.aiToScheme,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const businessCardInfoApi = (data = {}) => {
  if (data.query && data.query.type === 'share') {
    return requestHttp({
      api: schemesApi.businessCardOpenInfo,
      method: 'GET',
      module: 'um',
      querys: data.query || {}
    });
  } else {
    return requestHttp({
      api: schemesApi.businessCardInfo,
      method: 'GET',
      module: 'um',
      querys: data.query || {}
    });
  }
};

export const businessCardUpsertApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.businessCardUpsert,
    method: 'POST',
    module: 'um',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const businessCardTitleApi = (data = {}) => {
  if (data.query && data.query.type === 'share') {
    return requestHttp({
      api: schemesApi.businessCardOpenTitle,
      method: 'GET',
      module: 'um',
      querys: data.query || {}
    });
  } else {
    return requestHttp({
      api: schemesApi.businessCardTitle,
      method: 'GET',
      module: 'um',
      querys: data.query || {}
    });
  }
};

export const businessCardDownloadUrlApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.businessCardDownloadUrl,
    method: 'GET',
    module: 'um',
    querys: data.query || {}
  });
};

export const allTransferApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.allTransfer,
    method: 'GET',
    module: 'um',
    querys: data.query || {},
    backErrorCode: true
  });
};

export const schemeSectionUpdateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSectionUpdate,
    method: 'POST',

    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeSectionDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSectionDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeSetDeviceChangeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeSetDeviceChange,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeGetDeviceChangeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeGetDeviceChange,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeDelDeviceChangeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeDelDeviceChange,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const prodCountListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodCountList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const regionProdAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionProdAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const infoListSurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.infoListSurvey,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const delReginDevice = (data = {}) => {
  return requestHttp({
    api: schemesApi.delReginDevice,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const delReginIndoorDevice = (data = {}) => {
  return requestHttp({
    api: schemesApi.delReginIndoorDevice,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const delReginDevices = (data = {}) => {
  return requestHttp({
    api: schemesApi.delReginDevices,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const regionDevListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionDevList,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const prodListCountApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodListCount,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const addSurveyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.addSurvey,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {},
    timeout: 120 * 1000
  });
};

export const regionDeleteApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionDelete,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const regionCopyApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionCopy,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const regionRenameApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionRename,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const prodDeviceInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodDeviceInfo,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const prodDeviceEditApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodDeviceEdit,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeRegionProdAddApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeRegionProdAdd,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const topoDevlistApi = (data = {}) => {
  return requestHttp({
    api: `${schemesApi.topoDevlist}${data.query.schemeId}`,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const getdeviceTopoApi = (data = {}) => {
  return requestHttp({
    api: `${schemesApi.deviceTopo}${data.query.schemeId}`,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const reportTopoDataApi = (data = {}) => {
  return requestOpen({
    api: schemesApi.reportTopoData,
    method: 'GET',
    module: 'schemes',
    query: data.query || {}
  });
};

export const setdeviceTopoApi = (data = {}) => {
  return requestHttp({
    api: `${schemesApi.deviceTopo}${data.query.schemeId}`,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const schemeValidateApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeValidate,
    method: 'POST',
    module: 'schemes',
    params: data.body || {}
  });
};

export const getSchemeUseMsgStatusApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getSchemeUseMsgStatus,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const setSchemeUseMsgStatusApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.setSchemeUseMsgStatus,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const deviceEstLegendApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.deviceEstLegend,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getSchemeProdInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getSchemeProdInfo,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const getSchemeOutdoorProdApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getSchemeOutdoorProd,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const getMallListApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getMallList,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const getMallProdInfoApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.getMallProdInfo,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const schemeEmuBridgeApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.schemeEmuBridge,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const regionSortApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.regionSort,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const postFeedbackApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.postFeedback,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const autoLanScaleValidApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.autoLanScaleValid,
    method: 'POST',
    module: 'survey',
    querys: data.query || {},
    params: data.body || {}
  });
};

export const prodHeatmapAllDataApi = (data = {}) => {
  return requestHttp({
    api: schemesApi.prodHeatmapAllData,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

export const getPlanPrivacy = (data = {}) => {
  return requestHttp({
    api: schemesApi.getPlanPrivacy,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export const postPlanPrivacy = (data = {}) => {
  return requestHttp({
    api: schemesApi.getPlanPrivacy,
    method: 'POST',
    module: 'schemes',
    querys: data.query || {},
    params: data.data || {}
  });
};

/**
 * @name: linwc
 * @msg: 方案区域 - 楼层线材列表-按线材【scheme】
 * Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88%E5%8C%BA%E5%9F%9F/getRegionWireProdListUsingGET
 * @param {*} data
 * @return {*}
 */
export const getWireProdList = (data = {}) => {
  return requestHttp({
    api: schemesApi.getWireProdList,
    method: 'GET',
    module: 'schemes',
    querys: data
  });
};

/**
 * @name: linwc
 * @msg: 方案 - 获取障碍物材质【scheme】
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/getSysObstacleListUsingGET
 * @param {*} data
 * @return {*}
 */
export const getWallsCategoryList = (data = {}) => {
  return requestHttp({
    api: schemesApi.getWallsCategoryList,
    method: 'GET',
    module: 'survey',
    querys: data
  });
};

/**
 * @name: linwc
 * @msg: 4. 查看用户自定义墙体列表
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/getSysObstacleListUsingGET
 * @param {*} data
 * @return {*}
 */
export const getWallsList = (data = {}) => {
  return requestHttp({
    api: schemesApi.getWallsList,
    method: 'GET',
    module: 'survey',
    querys: data
  });
};

/**
 * @name: linwc
 * @msg: 方案 - 复制自定义障碍物【scheme】
 * @param {*} data
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/copyUserObstacleUsingPOST
 * @return {*}
 */
export const postCopyObstacle = (data = {}) => {
  return requestHttp({
    api: schemesApi.postCopyObstacle,
    method: 'POST',
    module: 'survey',
    querys: data.query || {},
    params: data.data || {}
  });
};

/**
 * @name: linwc
 * @msg: 方案 - 添加自定义障碍物【scheme】
 * @param {*} data
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/addUserObstacleUsingPOST
 * @return {*}
 */
export const postAddObstacle = (data = {}) => {
  return requestHttp({
    api: schemesApi.postAddObstacle,
    method: 'POST',
    module: 'survey',
    querys: data.query || {},
    params: data.data || {}
  });
};

/**
 * @name: linwc
 * @msg: 方案 - 修订自定义障碍物【scheme】
 * @param {*} data
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/updateUserObstacleUsingPOST
 * @return {*}
 */
export const postUpdateObstacle = (data = {}) => {
  return requestHttp({
    api: schemesApi.postUpdateObstacle,
    method: 'POST',
    module: 'survey',
    querys: data.query || {},
    params: data.data || {}
  });
};

/**
 * @name: linwc
 * @msg: 方案 - 自定义障碍物是否已被应用【scheme】
 * @param {*} data
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/serObstacleHasApplyUsingDELETE
 * @return {*}
 */
export const delHasAppliedObstacle = (data = {}) => {
  return requestHttp({
    api: schemesApi.delHasAppliedObstacle,
    method: 'DELETE',
    module: 'survey',
    querys: data.query || {},
    params: data.data || {}
  });
};

/**
 * @name: linwc
 * @msg: 方案 - 删除自定义障碍物【scheme】
 * @param {*} data
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/survey/doc.html#/default/%E5%A2%99%E4%BD%93%E9%9A%9C%E7%A2%8D%E7%89%A9%E7%AE%A1%E7%90%86/delUserObstacleUsingDELETE
 * @return {*}
 */
export const delObstacle = (data = {}) => {
  return requestHttp({
    api: schemesApi.delObstacle,
    method: 'DELETE',
    module: 'survey',
    querys: data.query || {},
    params: data.data || {}
  });
};

/**
 * @name: linwc
 * @msg: 方案- Light选型说明是否显示
 * @param {*} data
 * @Doc: https://lysoratech-enet-test.rj.link:6443/api/v1/schemes/doc.html#/default/%E6%96%B9%E6%A1%88/validateSchemesUsingGET
 * @return {*}
 */
export const checkLightHelp = (data = {}) => {
  return requestHttp({
    api: schemesApi.checkLightHelp,
    method: 'GET',
    module: 'schemes',
    querys: data.query || {}
  });
};

export * from './v2/scheme/index';
